import Time from './tools/time'
export const trunTime = (type, time) => Time.formatTime(type, time)